import { render, staticRenderFns } from "./radioChannel.vue?vue&type=template&id=6fa1b6da&"
import script from "./radioChannel.vue?vue&type=script&lang=js&"
export * from "./radioChannel.vue?vue&type=script&lang=js&"
import style0 from "./radioChannel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports